module.exports = __webpack_public_path__ + "3f16e137/img/share-icon.0f8a11b4.svg";